import React, { useState, useEffect } from "react";
import "../refinance/remaining-balance.css";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../../ProgressBar";
import NextBackButton from "../../NextBackButton";

export const EstimatedBudget = ({
  formData,
  setForm,
  navigation,
  step,
}) => {
  const [priceInputValue, setpriceInputValue] = useState(0);
  const [otherInputValue, setotherInputValue] = useState(0);
  const [priceInput, setpriceInput] = useState({
    0: "0",
    1: "110,000",
    2: "120,000",
    3: "130,000",
    4: "140,000",
    5: "150,000",
    6: "160,000",
    7: "170,000",
    8: "180,000",
    9: "190,000",
    10: "200,000",
    11: "210,000",
    12: "220,000",
    13: "230,000",
    14: "240,000",
    15: "250,000",
    16: "260,000",
    17: "270,000",
    18: "280,000",
    19: "290,000",
    20: "300,000",
    21: "310,000",
    22: "320,000",
    23: "330,000",
    24: "340,000",
    25: "350,000",
    26: "360,000",
    27: "370,000",
    28: "380,000",
    29: "390,000",
    30: "400,000",
    31: "410,000",
    32: "420,000",
    33: "430,000",
    35: "450,000",
    34: "440,000",
    36: "460,000",
    37: "470,000",
    38: "480,000",
    39: "490,000",
    40: "500,000",
    41: "510,000",
    42: "520,000",
    43: "530,000",
    44: "540,000",
    45: "550,000",
    46: "560,000",
    47: "570,000",
    48: "580,000",
    49: "590,000",
    50: "600,000",
    51: "610,000",
    52: "620,000",
    53: "630,000",
    54: "640,000",
    55: "650,000",
    56: "660,000",
    57: "670,000",
    58: "680,000",
    59: "690,000",
    60: "700,000",
    61: "710,000",
    62: "720,000",
    63: "730,000",
    64: "740,000",
    65: "750,000",
    66: "760,000",
    67: "770,000",
    68: "780,000",
    69: "790,000",
    70: "800,000",
    71: "810,000",
    72: "820,000",
    73: "830,000",
    74: "840,000",
    75: "850,000",
    76: "860,000",
    77: "870,000",
    78: "880,000",
    79: "890,000",
    80: "900,000",
    81: "910,000",
    82: "920,000",
    83: "930,000",
    84: "940,000",
    85: "950,000",
    86: "960,000",
    87: "970,000",
    88: "980,000",
    89: "990,000",
    90: "1,000,000",
    91: "1,025,000",
    92: "1,050,000",
    93: "1,075,000",
    94: "1,100,000",
    95: "1,125,000",
    96: "1,150,000",
    97: "1,175,000",
    98: "1,200,000",
    99: "1,225,000",
    100: "1,250,000",
    101: "1,275,000",
    102: "1,300,000",
    103: "1,325,000",
    104: "1,350,000",
    105: "1,375,000",
    106: "1,400,000",
    107: "1,425,000",
    108: "1,450,000",
    109: "1,475,000",
    110: "1,500,000",
    111: "1,525,000",
    112: "1,550,000",
    113: "1,575,000",
    114: "1,600,000",
    115: "1,625,000",
    116: "1,650,000",
    117: "1,675,000",
    118: "1,700,000",
    119: "1,725,000",
    120: "1,750,000",
    121: "1,775,000",
    122: "1,800,000",
    123: "1,825,000",
    124: "1,850,000",
    125: "1,875,000",
    126: "1,900,000",
    127: "1,925,000",
    128: "1,950,000",
    129: "1,975,000",
    130: "2,000,000",
    131: "2,050,000",
    132: "2,100,000",
    133: "2,150,000",
    134: "2,200,000",
    135: "2,250,000",
    136: "2,300,000",
    137: "2,350,000",
    138: "2,400,000",
    139: "2,450,000",
    140: "2,500,000",
    141: "2,550,000",
    142: "2,600,000",
    143: "2,650,000",
    144: "2,700,000",
    145: "2,750,000",
    146: "2,800,000",
    147: "2,850,000",
    148: "2,900,000",
    149: "2,950,000",
    150: "3,000,000",
  });

  const [isVisible, setIsVisible] = useState(true);
  const [error, setError] = useState(false);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  useEffect(() => {
    // Assume formData.RemainingBalance is a string like "100,000"
    if (formData.estimatedBudget) {
      const balanceValue = formData.estimatedBudget.replace(/,/g, ""); // Remove commas for comparison
      const index = Object.entries(priceInput).find(([key, value]) => value.replace(/,/g, "") === balanceValue)?.[0];

      if (index) {
        setpriceInputValue(Number(index));
      }
    }
  }, [formData, priceInput]);

  const slider = React.createRef();
  const sliderValue = React.createRef();
  console.log(priceInput[priceInputValue]);
  useEffect(() => {
    slider.current.setAttribute("min", 0);
    slider.current.setAttribute("max", Object.keys(priceInput).length - 1);
    const thumbSize = parseInt(
      window
        .getComputedStyle(sliderValue.current)
        .getPropertyValue("--thumb-size"),
      10
    );
    handleSliderValuePosition(slider.current, thumbSize);
  }, [priceInputValue]);

  const handlePricingSlide = (e) => {
    setpriceInputValue(e.target.value);
    handleSliderValuePosition(e.target);
    setError(false);
  };

useEffect(() => {
  // Get the display value with commas
  const displayValue = priceInput[priceInputValue];

  // Store the numeric value without commas
  const numericValue = displayValue.replace(/,/g, "");

  setForm({
    target: {
      name: "estimatedBudget",
      value: numericValue, // Store without commas
    },
  });
}, [priceInputValue]);

  const handleSliderValuePosition = (input, thumbSize) => {
    const multiplier = input.value / input.max;
    const thumbOffset = thumbSize * multiplier;
    const priceInputOffset = (thumbSize - sliderValue.current.clientWidth) / 2;
    sliderValue.current.style.left =
      input.clientWidth * multiplier - thumbOffset + priceInputOffset + "px";
  };
  const handleNextAndSubmit = () => {
    if (formData.estimatedBudget === "0") {
      return setError(true);
    }
    setError(false);
    navigation.next();
  };

   useEffect(() => {
     const urlParams = new URLSearchParams(window.location.search);
     const estimatedBudget = decodeURIComponent(urlParams.get("price") || "");
     console.log(estimatedBudget);

     if (estimatedBudget) {
       const price = estimatedBudget.replace(/[$,]/g, "");

       const nearestPrice = findNearestPrice(Number(price));

       setForm({ target: { name: "estimatedBudget", value: nearestPrice } });
     }
   }, []);

   const findNearestPrice = (price) => {
     const prices = Object.values(priceInput).map((p) =>
       Number(p.replace(/,/g, ""))
     );
     for (let i = 0; i < prices.length; i++) {
       if (prices[i] >= price) {
         return prices[i].toLocaleString();
       }
     }
     return prices[prices.length - 1].toLocaleString(); // Return the highest value if price is above all ranges
   };
  

  return (
    <div className="flex flex-col h-screen w-full">
      <div>
        <ProgressBar width={"35%"} />
        <div className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center">
          {transition((style, item) =>
            item ? (
              <animated.div style={style} className="mx-auto flex flex-col justify-center items-center">
                <h1 className="lg:pt-12 pt-6 pb-10 text-4xl text-blue-primary font-semibold text-center w-full">
                  What is your estimated project budget?
                </h1>
                <div className="pricing w-1/2 lg:w-auto">
                  <div className="pricing-slider center-content">
                    <label className="form-slider">
                      <input
                        type="range"
                        ref={slider}
                        value={priceInputValue}
                        onChange={handlePricingSlide}
                        name="homeValue"
                      />
                    </label>
                  </div>
                  <div ref={sliderValue} className="pricing-slider-value">
                    <h1 className="text-4xl font-medium text-gray-satan font-semibold text-center w-full">
                      ${priceInput[priceInputValue]}
                    </h1>
                  </div>
                </div>
                {error ? (
                  <div className="mt-4 -mb-10 text-center text-red-error">Please select a estimated project budget</div>
                ) : null}
              </animated.div>
            ) : null
          )}
        </div>
      </div>
      <NextBackButton callBack={handleNextAndSubmit} goBack={() => navigation.previous()} />
    </div>
  );
};

export default EstimatedBudget;
